import Vivaldi1 from '../../../media/Residentials/Vivaldi/Vivaldi.webp'
import Vivaldi2 from '../../../media/Residentials/Vivaldi/Vivaldi (2).webp'
import Vivaldi3 from '../../../media/Residentials/Vivaldi/Vivaldi (3).webp'
import Vivaldi4 from '../../../media/Residentials/Vivaldi/Vivaldi (4).webp'
import Vivaldi5 from '../../../media/Residentials/Vivaldi/Vivaldi (5).webp'
import Vivaldi6 from '../../../media/Residentials/Vivaldi/Vivaldi (6).webp'
import Vivaldi7 from '../../../media/Residentials/Vivaldi/Vivaldi (7).webp'
import Vivaldi8 from '../../../media/Residentials/Vivaldi/Vivaldi (8).webp'
import Vivaldi9 from '../../../media/Residentials/Vivaldi/Vivaldi (9).webp'


const Vivaldiimages =[
Vivaldi1,Vivaldi2,Vivaldi3,Vivaldi4,Vivaldi5,Vivaldi6,Vivaldi7,Vivaldi8,Vivaldi9
]

export default Vivaldiimages;